<template>
  <div class="content mine" >
    <div class="user flex-column">
      <div class="top">
        <img src="@/static/images/round.png" class="top-img" />
        <div class="top-info flex-column">
          <div class="bar">
            <img src="@/static/images/arrow-left-white.png"
            @click="back" />
            <div class="title flex-center">
              <span>用户中心</span>
            </div>
          </div>
          <div class="detail flex-row">
            <div class="logo">
              <img :src="[userinfo.img_url?userinfo.img_url:'/static/images/photo.png']" alt="">
            </div>
            <div class="right flex-1 flex-column">
              <div class="name">{{userinfo.wx_name?userinfo.wx_name:"游客"}}</div>
              <div v-if="userinfo.id" class="more flex-row">
                <div class="more-item">UID: {{userinfo.id || '--'}}</div>
                <div class="more-item" @click="showRecharge">
                  钱包余额：<span>{{userinfo.count?userinfo.count:0}} p</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="menu flex-wrap">
        <div v-for="(item, index) in userMenu" class="menu-item flex-row"
        @click="menuTap(index, item)">
          <img :src="item.icon" alt="" />
          <span>{{item.name}}</span>
        </div>
      </div>
    </div>

    <div v-if="userinfo.id" class="logout">
      <el-button @click="logOutTap" round>退出登录</el-button>
    </div>

    <!-- <div class="wraper_bg">
      <div class="info">
        <div class="info_photo">
          <img :src="[userinfo.img_url?userinfo.img_url:'/static/images/photo.png']" alt="">
        </div>
        <div class="info_name">
          <p class="info_name_call">
            {{userinfo.wx_name?userinfo.wx_name:"游客"}}
          </p>
          <p class="info_name_uid" v-if="userinfo.id">uid:{{userinfo.id}}</p>
        </div>
        <div class="info_balance" v-if="userinfo.id">
          <div class="router-link recharge btn" @click="showRecharge">
            余额充值
          </div>
          <div class="router-link sign btn" v-if="system_open == 1" @click="sign">
            签&nbsp;到
          </div>
        </div>

      </div>
      <div class="info_under">
        <div class="info_under_price  right-border" @click="navTo('../wallet')">
          <h3 class="info_id">{{userinfo.count?userinfo.count:0}}</h3>
          <p>余额 </p>
        </div>
        <div class="info_under_recharge " v-if="system_open == 1" @click="navTo('../integral')">
          <h3 class="info_id">{{userinfo.integral?userinfo.integral:0}}</h3>
          <p class="scoreWrap">积分
            <img class="helpIcon" src="/static/images/help.png" @click.stop="navTo('../rule')" alt="">
          </p>
        </div>
        <div class="info_under_price" v-if="system_open == 1" @click="navTo('../coupons')">
          <div class="info_under_price ">
            <h3 class="info_id">{{userinfo.coupons_num}}</h3>
            <p>优惠券</p>
          </div>
        </div>
      </div>

    </div>
    <div class="wraper_list wraper_list_shadow">
      <div class="weui-cell weui-cell_flex  weui-cell_select-after" v-if="userinfo.id">
        <div class="weui-cell__hd weui-cell_flex">
          <img src="/static/images/qianbao.png" alt="">
        </div>
        <div class="weui-cell__bd weui-cell_flex icon-select " id="">
          <router-link to="/wallet" class="router-link">
            钱包
          </router-link>
        </div>
      </div>
    </div>
    <div class="wraper_list wraper_list_shadow">
      <div class="weui-cell weui-cell_flex  weui-cell_select-after" v-if="userinfo.id" @click="editphone()">
        <div class="weui-cell__hd weui-cell_flex">
          <img src="/static/images/home.png" alt="">
        </div>
        <div class="weui-cell__bd weui-cell_flex icon-select " id="">
          常用号码
          <font class="margin-r">{{userinfo.phone}}</font>
        </div>
      </div>
      <div class="weui-cell weui-cell_flex  weui-cell_select-after" v-if="userinfo.id && system_open == 1">
        <div class="weui-cell__hd weui-cell_flex">
          <img src="/static/images/goods.png" alt="">
        </div>
        <div class="weui-cell__bd weui-cell_flex icon-select " id="">
          <router-link to="/goods" class="router-link">
            积分商城
          </router-link>
        </div>
      </div>
      <div class="weui-cell weui-cell_flex  weui-cell_select-after" v-if="userinfo.id">
        <div class="weui-cell__hd weui-cell_flex">
          <img src="/static/images/liuyan.png" alt="">
        </div>
        <div class="weui-cell__bd weui-cell_flex icon-select " id="">
          <router-link to="/proposal" class="router-link">
            投诉建议
          </router-link>
        </div>
      </div>
      <div class="weui-cell weui-cell_flex  weui-cell_select-after" v-if="userinfo.id" @click="clearOrder()">
        <div class="weui-cell__hd weui-cell_flex">
          <img src="/static/images/qingchu.png" alt="">
        </div>
        <div class="weui-cell__bd weui-cell_flex icon-select " id="">
          清除充值记录
        </div>
      </div>
    </div> -->

    <el-dialog title="钱包充值" :visible.sync="rechargeDialogVisible"  class="dialog">
      <!-- <el-input v-model="amount" placeholder="请输入充值金额（₱）"></el-input> -->
      <div class="amount-desc">此为充充充电子钱包余额</div>
      <!-- 充值金额选项 -->
      <LifeAmount v-model="amount" :list="balanceRules" size="22px" marginBottom="15px" />
      <div class="radio-area" v-if="configPayments && configPayments.length > 0">
        <el-radio-group
        v-model="payment"
        size="small"
        @change="handleRadioChange" >
          <el-radio
            class="radio-item "
            :label="item.code"
            v-for="item in configPayments"
            :key="item.code"
          >
            <img :src="item.icon || '../../static/images/'+item.name+'.png'" >
          </el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer btn-area">
        <el-button @click="rechargeDialogVisible = false" class="btn">取 消</el-button>
        <el-button type="primary" @click="rechargemoney" class="btn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="请使用扫码支付" :visible.sync="centerDialogVisible" width="300px" center>
      <div>
        <vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff" :dotScale="1"
          :logoSrc="downloadData.icon" :logoScale="0.2" :size="200"></vue-qr>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <navBar :idx="3"></navBar>
  </div>
</template>

<script>
  import { getUrlParam } from '@/util/util';
  import config from '@/config';

  const delay = (function() {
    let timer = 0
    return function(callback, ms) {
      clearTimeout(timer)
      timer = setInterval(callback, ms)
    }
  })()

  import navBar from '@/components/navBar';
  import vueQr from 'vue-qr'
  import LifeAmount from '@/components/life-amount.vue'

  export default {
    name: 'mine',
    components: {
      navBar,
      vueQr,
      LifeAmount
    },
    data() {
      return {
        system_open: 0,
        userinfo: {},
        amount: '',
        payments: [],
        configPayments: [],
        payment: 'weixin',
        rechargeDialogVisible: false,
        centerDialogVisible: false,
        downloadData: {
          url: '', //需要转化成二维码的网址
        },
        // 菜单列表
        userMenu: [
          {
            name: '我的订单',
            icon: require('@/static/images/mine/my-order.png'),
            isLogin: true
          },
          {
            name: '我的eSIM',
            icon: require('@/static/images/mine/my-esim.png'),
            isLogin: true
          },
          {
            name: '钱包余额明细',
            icon: require('@/static/images/mine/my-yue.png'),
            isLogin: true
          },
          {
            name: '问题反馈',
            icon: require('@/static/images/mine/my-fankui.png'),
            isLogin: true
          },
          // {
          //   name: '常用号码设置',
          //   icon: require('@/static/images/mine/my-haoma.png'),
          //   isLogin: true
          // },
          {
            name: '联系客服',
            icon: require('@/static/images/mine/my-kefu.png'),
            isLogin: false
          },
          {
            name: '清除充值记录',
            icon: require('@/static/images/mine/my-clear.png'),
            isLogin: true
          }
        ]
      }
    },
    computed: {
      balanceRules() {
        return this.$store.state.balanceRules
      }
    },
    mounted() {
      let auth_token = localStorage.getItem('auth_token');
      if (!auth_token) {
        // this.$message({
        //   message: "请先登录！",
        //   type: "warning",
        // })
        // setTimeout(() => {
        //   this.$router.push('/login');
        // }, 2000);
      } else {
         this.getUserInfo();
      }
      this.getConfigPayments();
    },
    methods: {
      logOutTap() {
        this.$confirm('确认退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          localStorage.removeItem('auth_token')
          this.$router.push('/');
        })
      },
      menuTap(index, item) {
        if (item.isLogin) {
          const auth_token = localStorage.getItem('auth_token');
          if (!auth_token) {
            this.getLogin()
            return
          }
        }
        switch(index) {
          case 0: //我的订单
            this.$router.push('/historycard')
            break;
          case 1: //我的eSIM
            this.$router.push('/myEsim')
            break;
          case 2: //账户余额明细
            this.$router.push('/wallet')
            break;
          case 3: //问题反馈
            this.$router.push('/proposal')
            break;
          // case 3: //常用号码设置
          //   this.editphone()
          //   break;
          case 4: //联系客服
            this.$router.push('/customer')
            break;
          case 5: //清除充值记录
            this.clearOrder()
            break;
        }
      },
      back() {
        this.$router.go(-1)
      },
      getLogin() {
        // if (!auth_token) {
        const code = this.$route.query.code || getUrlParam('code');
        switch (this.$client) {
            case 'wxh5':
              if (code) {
                this.$api.request('Wx/grantLogin', {
                  code: code,
                  settlement: config.SETTLEMENT
                }).then(({ data }) => {
                  this.$message({
                    message: "登录成功！",
                    type: "success"
                  })
                  this.getUserInfo()
                }).catch(error => {
                  this.$message({
                    message: "登录失败！",
                    type: "warning"
                  })
                  this.$router.push('/');
                });
              } else {
                window.location.href = config.api_url + 'Wx/grant?settlement=' + config.SETTLEMENT;
              }
              break;
            case 'magapp':
              if (code) {
                this.$api.request('System/grantLogin', {
                  code: code
                }).then(({ data }) => {
                  this.$message({
                    message: "登录成功！",
                    type: "success"
                  })
                  this.getUserInfo()
                }).catch(error => {
                  this.$message({
                    message: "登录失败！",
                    type: "warning"
                  })
                  this.$router.push('/');
                });
              } else {
                window.location.href = config.login_url;
              }
              break;
            case 'h5':
              this.$confirm(' ', '请选择', {
                distinguishCancelAndClose: true,
                confirmButtonText: '登录充值',
                cancelButtonText: '游客充值'
              }).then((action) => {
                this.$router.push('/login');
              }).catch(() => {});
              break;
            default:
              this.$message({
                message: "非法客户端！",
                type: "warning"
              })
              break;
        }
        // }
      },
      navTo(url) {
        this.$router.push('' + url)
      },
      getUserInfo() {
        this.$api
          .request('Member/getInfo', {})
          .then(({ data }) => {
            this.userinfo = data;
            this.system_open = data.system_open;
          })
          .catch(error => {
            this.$message({
              message: error+"获取用户信息失败！",
              type: "warning"
            })
          });
      },
      sign() {
        this.$api
          .request('Member/sign')
          .then(({ data }) => {
            this.$message({
              message: "签到成功",
              type: "success"
            })
            this.userinfo.integral = data;
          })
          .catch(error => {
            this.$message({
              message: error,
              type: "warning"
            })
          });
      },
      clearOrder() {
        this.$confirm('此操作将删除您的全部充值记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api
            .request('Order/del', {})
            .then(({ data }) => {
              this.$message({
                message: data.msg,
                type: "warning"
              })
            })
            .catch(error => {
              this.$message({
                message: "删除失败！",
                type: "warning"
              })
            });
        }).catch(() => {
        });
      },
      editphone() {
        this.$router.push('/phoneset');
      },
      magpay(params) {
        let config = {
          money: params.pay_amount,
          title: params.description,
          des: params.description,
          payWay: {
            // wallet: 1,
            weixin: 1,
            alipay: 1,
          },
          orderNum: params.oid,
          unionOrderNum: params.order_sn,
          type: params.description
        };
        mag.pay(config, () => {
          setTimeout(() => {
            this.$message({
              message: "支付成功",
              type: "success"
            })
          }, 50);
        }, () => {
          this.$message({
            message: "支付失败",
            type: "warning"
          })
        });
      },
      wxpay(params) {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': params.appId,
            'timeStamp': params.timeStamp,
            'nonceStr': params.nonceStr,
            'package': params.package,
            'signType': params.signType,
            'paySign': params.paySign
          },
          (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.$message({
                message: "支付成功",
                type: "success"
              })
              this.$router.go(0);
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
              this.$router.go(0);
            }
        });
      },
      // 获取配置的支付方式列表
      async getConfigPayments() {
        try {
          const { data } = await this.$api.request('System/init', {
            position: 1,
            client: this.$client
          })
          if (typeof data.config_payments == 'object' && Array.isArray(data.config_payments)) {
            this.$set(this, 'configPayments', data.config_payments)
            // 默认选择第一个支付方式
            if (this.configPayments.length > 0) {
              this.payment = this.configPayments[0].code
            }
          }
        } catch (error) {
          console.error('获取支付方式列表失败:', error)
        }
      },
      showRecharge() {
        // 如果没有选择支付方式，默认选择第一个
        if (!this.payment && this.configPayments.length > 0) {
          this.payment = this.configPayments[0].code
        }
        this.rechargeDialogVisible = true;
      },
      openUrl(url) {
        if (url) {
          window.open(url, '_blank');
        }
        this.$confirm("支付提示","",{
          iconClass: "el-icon-question",//自定义图标样式
            confirmButtonText: "支付完成",//确认按钮文字更换
            cancelButtonText: "取消",//取消按钮文字更换
            showClose: true,//是否显示右上角关闭按钮
            type: "success",//提示类型  success/info/warning/error
        }).then((data) => {
          let auth_token = localStorage.getItem('auth_token');
          if (auth_token) {
            this.$router.push('/historycard');
          }
        }).catch((err) => {

        });
      },
      rechargemoney() {
        // let exp = /^[1-9]\d*$/;
        // if (!exp.test(this.amount)) {
        //   this.$message({
        //     message: "请输入正确的金额！",
        //     type: "warning"
        //   })
        //   return;
        // }
        if (!this.amount) {
          this.$message({
            message: "请选择充值金额！",
            type: "warning"
          })
          return
        }
        this.rechargeDialogVisible = false;
        
        this.$api
          .request('Order/create', {type:2, settlement: config.SETTLEMENT, client: this.$client, amount: this.amount, payment: this.payment})
          .then(({ data }) => {
            if (data.result == true) {
              this.$message({
                message: "支付成功！",
                type: "success"
              })
            } else if (data.result && data.result.new == true) {
              // 新支付返回结构
              let paymentType = data.result.payment_type || 'link';
              let out_trade_no = data.result.sn || data.result.order_no || '';
              console.log('paymentType:', paymentType)
              switch(paymentType) {
                case 'qrcode':
                  // 显示二维码弹窗
                  this.centerDialogVisible = true;
                  this.downloadData.url = data.result.pay_url || '';
                  if (out_trade_no) {
                    delay(() => {
                      this.checkorder(out_trade_no)
                    }, 3000)
                  }
                  break;
                case 'link':
                  this.openUrl(data.result.pay_url);
                case 'jsapi':
                  // jsapi类型：调用微信支付
                  this.wxpay(data.result);
                  break;
                case 'app':
                  // app类型：调用马甲APP支付
                  this.magpay(data.result);
                  break;
                default:
                  this.$message({
                    message: "暂不支持的支付类型！",
                    type: "warning"
                  })
                  break;
              }
            } else {
              // 旧支付返回结构，保持原有逻辑
              let out_trade_no = '';
              switch(this.$client) {
                case 'h5':
                  if (this.payment == 'weixin') {
                    if (data.result.is_wap) {
                      this.openUrl(data.result.h5_url);
                    } else {
                      this.centerDialogVisible = true;
                      this.downloadData.url = data.result.code_url;
                      out_trade_no = data.result.out_trade_no;
                    }
                  } else {
                    switch (data.type) {
                      case "1":
                        if (this.payment == 'gcashpay') {
                          this.openUrl(data.result.data.content);
                        } else {
                          this.centerDialogVisible = true;
                          this.downloadData.url = data.result.data.content;
                          out_trade_no = data.result.data.outTradeNo;
                        }
                        break;
                      case "2":
                        switch (this.payment) {
                          case "alipay":
                            this.centerDialogVisible = true;
                            this.downloadData.url = data.result.results.pay_url;
                            out_trade_no = data.result.results.out_trade_no;
                            break;
                          case "gcashpay":
                            this.openUrl(data.result.results.api_url);
                            break;
                        }
                        break;
                      default:
                        this.$message({
                          message: "暂不支持的支付类型！",
                          type: "warning"
                        })
                        break;
                    }
                  }

                  if (out_trade_no != '') {
                    delay(() => {
                      this.checkorder(out_trade_no)
                    }, 3000)
                  }
                  break;
                case 'wxh5':
                  this.wxpay(data.result);
                  break;
                case 'magapp':
                  this.magpay(data.result);
                  break;
                default:
                  this.$message({
                    message: "暂不支持的客户端！",
                    type: "warning"
                  })
                  break;
              }
            }
          })
          .catch(error => {
            this.$message({
              message: error+"下单失败,请联系客服！",
              type: "warning"
            })
          });
      },
      checkorder(sn) {
        this.$api
          .request('Order/check', {sn})
          .then(({ data }) => {
              this.$message({
                message: "支付成功",
                type: "success"
              })
              this.$router.go(0);
          })
          .catch(error => {
            console.log(error)
          });
      },
      handleRadioChange(e) {
        this.payment = e;
      },
    }
  }
</script>

<style scoped lang="less">
  @import url("../../static/less/mine.less");

  .logout {
    margin-top: 60px;
    padding: 0 22px;

    /deep/ .el-button {
      width: 100%;
      padding: 14px 23px;
      border-radius: 30px;
    }
  }

  .user {
    .menu {
      margin-top: 20px;
      text-align: left;
      padding: 0 12px;
      &-item {
        width: calc((100% - 6px) / 2);
        margin-right: 6px;
        height: 37px;
        border: 0.5px solid rgb(238, 238, 238);
        border-radius: 5px;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.15);
        background: #F8F8FA;
        padding: 0 5px 0 29px;
        margin-top: 10px;
        &:nth-child(2n) {
          margin-right: 0;
        }
        &:nth-child(-n+2) {
          margin-top: 0;
        }
        &:active {
          opacity: .7;
        }
        img {
          width: 20px;
          height: auto;
          margin-right: 8px;
        }
        span {
          color: #727272;
          font-family: Poppins;
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
        }
      }
    }
    .top {
      position: relative;
      text-align: left;
      &-img {
        width: 100%;
        height: auto;
      }
      &-info {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        padding: 0 12px;

        .detail {
          margin-top: 12px;
          .logo {
            width: 53px;
            img {
              width: 100%;
              height: auto;
            }
          }
          .right {
            padding-left: 16px;
            .name {
              color: #fff;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 500;
              line-height: 24px;
            }
            .more {
              line-height: 24px;
              margin-top: 4px;
              &-item {
                color: #fff;
                font-family: 思源黑体;
                font-size: 13px;
                font-weight: 500;
                margin-right: 40px;
                &:last-child {
                  margin-right: 0;
                }
                span {
                  color: #fff;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                }
              }
            }
          }
        }

        .bar {
            /* margin-top: 67px; */
            margin-top: 32px;
            text-align: center;
            position: relative;
            img {
              position: absolute;
              width: 24px;
              height: auto;
              left: 0;
              top: 0;
              bottom: 0;
              margin: auto;
            }
            .title {
              height: 24px;
              span {
                color: #fff;
                font-family: 思源黑体 CN;
                font-size: 18px;
                font-weight: 900;
                line-height: 18px;
                letter-spacing: 0.7px;
                margin-top: -2.7px;
              }
            }
        }
      }
    }
  }

  .none {
    display: none !important;
  }

  .info_under .divide-line::after {
    border-right: rgba(0, 0, 0, 0) !important;
  }

  .el-input__inner {
    position: relative;
  }

  .margin-r {
    margin-left: 10px;
  }

  .cphone {
    border: 1px solid #cc6810;
    color: #cc6810;
    border-radius: 4px;
    margin-left: 10px;
  }

  .radio-area {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 30px 0 0 0;
    flex-wrap: wrap;
  }

  .radio-item {
    padding-right: 7px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .radio-item img{
    width:80px;
  }

  .btn-area {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn-area .btn {
    padding: 9px 15px;
  }

  .el-dialog {
    border-radius: 4px;
  }

  .dialog {
    .amount-desc {
      // text-align: left;
      margin-bottom: 30px;
      font-size: 13px;
      color: #BD242B;
      letter-spacing: 0.6px;
    }
    /deep/ .el-dialog__body {
      padding: 0 20px;
    }
  }

  .dialog .el-dialog {
    padding-bottom: 30px;
  }
  .info_under_recharge{

  .scoreWrap{
    display: flex;
    align-items: center;
    justify-content: center;
  }
    .helpwrap{
      height: 19px;
      line-height: 19px;
      display: inline-block;
    }
    .helpIcon {
       width:19px;
       height: 19px;
       margin-left: 10px;
     }

  }

</style>



// WEBPACK FOOTER //
// src/page/mine.vue